// extracted by mini-css-extract-plugin
export default {"forgotBtnStyle":"ButtonV2_forgotBtnStyle__Vy3uT","light4":"ButtonV2_light4__+NLaI","light5":"ButtonV2_light5__f3vuy","light6":"ButtonV2_light6__+qhZk"};